var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { class: _vm.slideInClass },
        [
          _c("header", [
            _c("div", { staticClass: "title-container" }, [
              _c("h4", [_vm._v("Welche weitere Software beherrscht du?")]),
              _vm._v(" "),
              _c("div", { staticClass: "close-container" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.closeFan(false)
                      }
                    }
                  },
                  [_c("Icon", { attrs: { icon: "close" } })],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "scrollbar-check flex-grow-1" },
            [
              _c("JonInfo", { staticClass: "mt-0 mb-4" }),
              _vm._v(" "),
              _c("div", { staticClass: "sections" }, [
                _c(
                  "section",
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.hasItems
                            ? "Weitere Software hinzufügen"
                            : "Jede Software einzeln eingeben"
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("SkillsSoftwareSpecial", {
                      attrs: { meta: "meta" },
                      on: {
                        hasItems: function($event) {
                          _vm.hasItems = $event
                        }
                      },
                      model: {
                        value: _vm.software,
                        callback: function($$v) {
                          _vm.software = $$v
                        },
                        expression: "software"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "footer",
            [
              _c("Button", {
                attrs: {
                  text: "Fertig",
                  disabled: !_vm.software,
                  icon: "checkmark"
                },
                on: {
                  click: function($event) {
                    return _vm.closeFan(true)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCompletionCheckPopUp
            ? _c("CompletionCheckPopUp", {
                attrs: {
                  title: "Weitere Software",
                  "ok-button-text": "Keine weiteren Kenntnisse"
                },
                on: {
                  abort: function($event) {
                    _vm.showCompletionCheckPopUp = false
                  },
                  skip: function($event) {
                    return _vm.closeFan(true, true)
                  },
                  ok: function($event) {
                    return _vm.closeFan(true, false)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "info",
                      fn: function() {
                        return [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.completionCheckInfo)
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1703795803
                )
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }